if (window.location.pathname === "/square-setup-call-back"){
	window.location.replace(window.location.origin + "#/square-setup" + window.location.search)
}

import Vue from "vue";
import App from "@/AppPortal.vue";
import router from "@/router/portal.js";
import store from "@/store/portal.js";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import VueCurrencyFilter from 'vue-currency-filter';
import VueTheMask from 'vue-the-mask'

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

const moment = require('moment-timezone');
Vue.prototype.moment = moment

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueCurrencyFilter, {
	symbol: '$',
	thousandsSeparator: ',',
	fractionCount: 2,
	fractionSeparator: '.',
	symbolPosition: 'front',
	symbolSpacing: false
});
Vue.use(VueTheMask)
Vue.filter('phone', function (phone) {
    return phone===null?"":phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});
Vue.filter("decimalNumber", function (value, decimal) {
    return value===undefined || value===null? '-' : value.toFixed(decimal);
});

Vue.prototype.$d2c = function(x) {
	return Math.round(x * 100)	  
}
Vue.prototype.$c2d = function(x) {
	return x / 100.0	  
}
Vue.prototype.$deepCopy = (_obj) => {
	return JSON.parse(JSON.stringify(_obj))
}
Vue.prototype.$Permission = Object.freeze({"Root" : 1, "SysAdmin" : 11, "OrgAdmin" : 21, "LocAdmin" : 31, "NoAccess" : 10000})
Vue.prototype.canSysAdmin = ({userPermissionLevel}) => {
	return userPermissionLevel <= Vue.prototype.$Permission.SysAdmin;
}
Vue.prototype.canOrgAdmin = ({userPermissionLevel}) => {
	return userPermissionLevel <= Vue.prototype.$Permission.OrgAdmin;
}

Vue.prototype.isUserNoAccess = ({userPermissionLevel}) => {return userPermissionLevel === Vue.prototype.$Permission.NoAccess;}
Vue.prototype.isUserRoot = ({userPermissionLevel}) => {
	return userPermissionLevel === Vue.prototype.$Permission.Root;
}

Vue.prototype.toast = (vm, {msg, variant, appendToast}) => {
	vm.$bvToast.toast(msg, {
		title: 'Response',
		autoHideDelay: 3000,
		variant: variant || "primary",
		solid: true,
		appendToast: appendToast || true
	})
}

Vue.prototype.$SET_LS = (key, value) => {	localStorage.setItem(key, value) }
Vue.prototype.$GET_LS = (key) => {	return localStorage.getItem(key) }
Vue.prototype.$HashCode = s => s.split('').reduce((a, b) => { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0)
Vue.prototype.$zeroPad = (nr,base) => {
	var  len = (String(base).length - String(nr).length)+1;
	return len > 0? new Array(len).join('0')+nr : nr;
}

Vue.config.productionTip = false;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, { locale });
// let HOST_NAME = window.location.hostname
// const API_URL = HOST_NAME == 'localhost' || HOST_NAME.includes('localhost')|| HOST_NAME.indexOf('localhost') ? ('https://157.245.137.53:5000/api') : (process.env.API_URL || '/api');

const API_URL = (process.env.API_URL || '/api')
import Axios from 'axios';
Vue.prototype.$axios = Axios;
Vue.prototype.$http = Axios.create({
	withCredentials: true,
	baseURL:API_URL,
});
Vue.prototype.$http.interceptors.response.use((res)=>{
    return res;
});
Vue.prototype.$http.defaults.headers.post['Accept'] = 'application/json';
Vue.prototype.$http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.prototype.dateDiff = (duration) => {
	var r = duration._data
	var cd = ''
	Object.keys(r).reverse().forEach((key) => {
	  if (r[key] > 0) {
		if(key !== "milliseconds") {
		  cd += r[key] + (key === "milliseconds" ? "ms" : key.charAt(0)) + ' '
		}
	  }
	})
	return cd.trim()
};

import resize from 'vue-resize-directive';
Vue.directive('resize',	resize)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
